import { XMarkIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import FocusTrap from 'focus-trap-react';
import { useEffect } from 'react';

export const ModalWrapper = ({
  children,
  onClose,
  closeOnOuterClick,
  customClose = false,
  large = false,
  medium = false,
  trapFocus = true,
}) => {
  useEffect(() => {
    const closeOnEscapePress = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', closeOnEscapePress);
    return () => {
      window.removeEventListener('keydown', closeOnEscapePress);
    };
  }, [onClose]);

  const contents = (
    <div
      className={clsx(
        'relative m-2 max-h-[90%] w-[90%] overflow-x-auto overflow-y-scroll rounded-sm bg-white p-8 text-blue md:w-[600px]',
        large && '!p-10 md:!w-[85%]',
        medium && 'md:!w-[55%]',
      )}
      onClick={e => e.stopPropagation()}
    >
      {!customClose && (
        <div className="flex justify-end">
          <button
            aria-label="close"
            className="flex cursor-pointer items-center gap-1 font-bold"
            onClick={onClose}
            type="button"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
      )}
      {children}
    </div>
  );

  return (
    <div
      className="fixed left-0 top-0 z-[9999] flex h-screen w-screen items-center justify-center bg-[rgba(100,100,100,0.55)] backdrop-blur-sm"
      onClick={() => (closeOnOuterClick ? onClose() : null)}
    >
      {trapFocus ? <FocusTrap>{contents}</FocusTrap> : contents}
    </div>
  );
};
